import { render, staticRenderFns } from "./priceMaintenance.vue?vue&type=template&id=b312c94c&scoped=true"
import script from "./priceMaintenance.vue?vue&type=script&lang=js"
export * from "./priceMaintenance.vue?vue&type=script&lang=js"
import style0 from "./priceMaintenance.vue?vue&type=style&index=0&id=b312c94c&prod&lang=scss&scoped=true"
import style1 from "./priceMaintenance.vue?vue&type=style&index=1&id=b312c94c&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b312c94c",
  null
  
)

export default component.exports